import { ClipboardCheckIcon, ClipboardListIcon, SchoolIcon, SearchIcon, SproutIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Bonus = {
  number: string;
  title: string;
  description: string;
  icon: LucideIcon;
};

export const bonuses: Bonus[] = [
  {
    number: '1',
    title: '30 Schede di Attività in Classe sulla Gestione Ambientale',
    description: '30 schede di attività pronte da usare in classe sui temi della gestione ambientale.',
    icon: ClipboardListIcon,
  },
  {
    number: '2',
    title: 'Kit di Verifica sulla Gestione Ambientale: Quiz e Prove con Soluzioni',
    description: 'Quiz e prove di verifica con le relative soluzioni.',
    icon: ClipboardCheckIcon,
  },
  {
    number: '3',
    title: '20 Casi Pratici di Gestione Ambientale da Analizzare e Risolvere',
    description: 'Casi pratici da analizzare e risolvere in classe.',
    icon: SearchIcon,
  },
  {
    number: '4',
    title: '20 Progetti Ambientali per la Classe, la Scuola e la Comunità',
    description: 'Progetti ambientali da realizzare in classe, a scuola e nella comunità.',
    icon: SproutIcon,
  },
  {
    number: '5',
    title: 'Guida Pratica: 30 Strategie di Gestione Ambientale per la Scuola',
    description: 'Una guida pratica con 30 strategie di gestione ambientale da applicare a scuola.',
    icon: SchoolIcon,
  },
];
